package dev.kuml.portal.web.share

/**
 * R-21: builds the absolute freigabe-URL CLIENT-side out of `window.location.origin` + `/s/` +
 * [token]. Bewusst kein serverseitiger Base-URL-Konfigurationsknopf: der waere fehlkonfigurierbar
 * (falscher Host in der verschickten URL) und muesste in dev/staging/prod je gepflegt werden -- der
 * Ursprung, unter dem der Nutzer den Link gerade erzeugt, ist per Definition korrekt.
 */
public object ShareUrl {
    public fun forToken(
        origin: String,
        token: String,
    ): String = "${origin.trimEnd('/')}/s/$token"
}
